<span fxLayout="row" fxFlex="100" fxLayoutAlign="center start">
  <span fxLayout="column" class="position-relative lane-body" fxFlex="0 1 900px" fxFlex.xs="100" fxFlex.sm="100">
    <span *ngIf="!loading && swimlane.items && swimlane.items.length > 0" fxLayout="column"
      fxLayoutAlign="center center">
      <span fxLayout="row" fxLayoutAlign="space-between center" class="res-pad-lr-0-20 carousel-fix-width w-100"
        fxLayoutGap="10px">

        <h2 *ngIf="tvLane" class="primary-color mat-headline-1 mb10px clickable" [routerLink]="['/tv', currentDate]">
          {{swimlane.title}}</h2>
        <h2 *ngIf="!tvLane && swimlane.titleButton" class="primary-color mat-headline-1 mb10px"><a
            [href]='swimlane.titleButton.uri'
            class="primary-color mat-headline-1 mb10px text-decoration-none">{{swimlane.title}}</a></h2>
        <h2 *ngIf="!tvLane && !swimlane.titleButton" class="primary-color mat-headline-1 mb10px">{{swimlane.title}}</h2>


        <a *ngIf="tvLane" class="f-hint-link icon-position text-decoration-none black mb10px text-nowrap" fxLayout="row"
          fxLayoutAlign="center center" [routerLink]="['/tv', currentDate]">
          <span>{{'swimlane.toTv' | translate | uppercase}}</span>
          <mat-icon color="primary" class="fs22">keyboard_arrow_right</mat-icon>
        </a>
        <a *ngIf="!tvLane && swimlane.titleButton"
          class="f-hint-link icon-position text-decoration-none black mb10px text-nowrap" fxLayout="row"
          fxLayoutAlign="center center" [href]='swimlane.titleButton.uri'>
          <span>{{swimlane.titleButton.label | uppercase}}</span>
          <mat-icon color="primary" class="fs22">keyboard_arrow_right</mat-icon>
        </a>
      </span>
    </span>

    <button *ngIf="rightVisible()" class="absolute-zero right-arrow clickable swimlane-arrow-button"
      [ngStyle]="{'top.px': container.clientHeight/2}" (click)="scrollRight()">
      <img src="assets/media/hover_arrows_swimlane_right.svg" [alt]="'common.right' | translate">
    </button>
    <button *ngIf="leftVisible()" [ngStyle]="{'top.px': container.clientHeight/2}"
      class="absolute-zero left-arrow clickable swimlane-arrow-button" (click)="scrollLeft()">
      <img src="assets/media/hover_arrows_swimlane_left.svg" [alt]="'common.left' | translate">
    </button>

    <span fxLayout="row" fxLayoutAlign="start start" class="overflow-auto scrollbar-off" #container [input]="swimlane"
      scrollTracker [id]="swimlane?.title + ' ' + swimlane?.swimlaneclass + ' ' + swimlane?.items?.length">
      <span fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="start" class="carousel-fix-width"
        *ngIf="!loading && swimlane.items && swimlane.items.length > 0">
        <span fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="start start" fxFlex="0 1">
          <span fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start start">
            <span class="res-width-0-5 mobile-only"></span>
            <a *ngFor="let m of swimlane.items; trackBy: trackSwItems; let i = index" fxLayout="column"
              aria-label="Zum Text" class="mb-1 clickable"
              [ngClass]="{'carousel-card-big': bigCards, 'carousel-card': !bigCards}" [routerLink]="swimlaneLinks[i]">
              <span class="h-100 position-relative overflow-hidden">
                <img [src]="m.imagelow ? (m.imagelow | safe: 'resourceUrl') : PLACEHOLDER_IMAGE_WITH_PATH"
                  class="carousel-card-image" [alt]="m.title + ' - ' + 'extra.image' | translate"
                  (load)="imageLoaded = true" [class.loaded]="imageLoaded" (error)="onImageError($event)"
                  fetchpriority="low" loading="lazy">
                <span class="overlay-shade-b position-absolute overfill zero-pos">
                  <span fxLayout="column" fxLayoutAlign="space-between" class="h-100 p14px">
                    <span fxLayout="row" fxLayoutAlign="space-between">
                      <span *ngIf="m.itemclass !== sic.Redtext">
                        <img *ngIf="m.rating === 4" class="image-size-35x35"
                          [alt]="'searchList.selectors.ratingOptions.4' | translate"
                          src="assets/media/rating_badge.svg">
                        <img [alt]="'extra.socialmedia' | translate" *ngIf="m.itemclass === sic.Ytbesprechung"
                          class="image-size-35x35" src="assets/media/ico_socialmedia.svg">
                      </span>
                      <span fxLayout="row" fxLayoutGap="6px" *ngIf="m.itemclass !== sic.Redtext">
                        <app-age-category-badge class="image-size-35x35" *ngIf="m.altersfreigabe && m.rating > 2"
                          [ageCategory]="m.altersfreigabe"></app-age-category-badge>
                        <app-traffic-lights class="image-size-18x46" [rating]="m.rating"></app-traffic-lights>
                      </span>

                    </span>
                    <span fxLayout="column" class="text-white">
                      <span class="f-preview-overline">
                        {{m.itemclass === sic.Besprechung ? (m.genre | uppercase) : ""}} {{((m.itemclass === sic.Special
                        || m.itemclass === sic.Redtext) && m.topos && m.topos.length > 0) ?
                        (m.topos | uppercase) : ""}}
                      </span>
                      <span class="overflow-hidden ellipsis"
                        [ngClass]="((m.itemclass === sic.Special ||  m.itemclass === sic.Redtext) &&  bigCards) ? 'f-preview-summary-headline' : 'f-preview-headline'">
                        <p class="nice-link margin-0">{{m.title}}</p>
                      </span>
                      <span *ngIf="hasSrc(m)" class="f-preview-subline src-box">
                        {{getText(m.srclist)}}
                      </span>
                      <span *ngIf="(m.itemclass === sic.Special) && (m.unterschrift_kachel)"
                        class="f-preview-summary-subline">
                        <p>{{m.unterschrift_kachel}}</p>
                      </span>
                      <span *ngIf="(m.itemclass === sic.Redtext) && (m.unterschrift_kachel)"
                        class="f-preview-summary-subline">
                        <p>{{m.unterschrift_kachel}}</p>
                      </span>
                    </span>
                  </span>
                </span>

              </span>
            </a>
            <span class="res-width-0-5 mobile-only"></span>
          </span>
        </span>
      </span>
      <span *ngIf="loading">
        <mat-spinner mode="indeterminate" diameter="10px"></mat-spinner>
      </span>
    </span>
  </span>
</span>